<template>
    <div class="popup-alert" :class="hidePopup">
        <div>
            <div>{{"Please check that the PDQ is idle and no action is prompted on its screen, that its network and power cables are correctly connected and that it is not in StandAlone Mode. Also ensure that the PDQ is not currently in use at another till. Finally, restart the PDQ and, if the problem persists, please contact Customer Support." | translate}}</div>
            <div class="close-popup cursor" @click="closePopup">{{"Retry" | translate}}</div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      hidePopup: 'hide'
    }
  },
  computed: {
    ...mapGetters([
      'isTerminalAvailableAfterRequest',
      'pageRedirectKey'
    ])
  },
  watch: {
    isTerminalAvailableAfterRequest (newValue) {
      if (!newValue) {
        this.hidePopup = 'show'
      }
    }
  },
  methods: {
    closePopup () {
      switch (this.pageRedirectKey) {
        case 'reload':
          location.reload()
          break
        default:
          this.$router.push({name: 'Home'})
          break
      }
    }
  },
  components: {
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .popup-alert {
        background-color: rgba(0,0,0,0.6);
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1022;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .popup-alert > div:first-child {
        background-color: #FFF;
        width: 50vw;
        height: 50vh;
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 20px;
        box-sizing: border-box;
        color: #333;
        font-size: 16px;
        position: relative;
        flex-direction: column;
        text-align: center;
    }
    .close-popup {
        bottom: 50px;
        width: 100px;
        height: 32px;
        background-color: #ff971c;
        border: none;
        color: #FFF;
        margin-bottom: 15px;
        margin-top: 5px;
        text-transform: uppercase;
        transition: background-color 0.2s linear;
        align-items: center;
        justify-content: center;
        display: flex;
    }
    .close-popup:hover {
        background-color: #333;
    }
    .hide {
        display: none;
    }
    .show {
        display: flex;
    }
</style>



// WEBPACK FOOTER //
// src/components/No-terminal.vue